module.exports = __webpack_public_path__ + "static/media/img3-1.3271663f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/nutricheck_foliar/FE/img3-1.png
// module id = 2143
// module chunks = 3